import VueCurrencyInput from '@ui-common/vue-currency-input';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueSlider from '@ui-common/vue-slider';
import VueTooltip from '@ui-common/vue-tooltip';
import debounce from 'lodash-es/debounce';

const INTERVAL = 1000;
const roundToInterval = (amount) => Math.round(amount / INTERVAL) * INTERVAL;
const OTP_CONVERTABLE_MAGIC_VALUE = 20000;
const OTP_FINAL_MAGIC_VALUE = 20001;
const otpModifier = (val) => (val == OTP_CONVERTABLE_MAGIC_VALUE ? OTP_FINAL_MAGIC_VALUE : val);
const otpReverseModifier = (val) => (val == OTP_FINAL_MAGIC_VALUE ? OTP_CONVERTABLE_MAGIC_VALUE : val);
const setMax = (value, max) => Math.min(value, max);
export default {
	data() {
		return {
			model: {
				amount: null,
				duration: null
			},
			amountInput: null,
			monthSlider: null,
			interval: INTERVAL,
			amountTooltip: false
		};
	},
	props: {
		durations: {
			required: true
		},
		minimumAmount: {
			required: true
		},
		maximumAmount: {
			required: true
		},
		defaultAmount: {
			required: true
		}
	},
	components: {
		VueCurrencyInput,
		VueSelect,
		VueSelectOption,
		VueSlider,
		VueTooltip
	},
	watch: {
		'model.duration'() {
			this.calculate();
		},
		'model.amount'(val) {
			this.amountInput = otpModifier(val);
			this.model.amount = this.amountInput;
			this.calculate();
		}
	},
	methods: {
		calculate: debounce(function () {
			this.$emit('on-calculate', this.model);
		}, 300),
		otpModifier,
		otpReverseModifier,
		updateAmountSlider() {
			let modulo = this.amountInput % this.interval;
			if (modulo != 0) {
				this.amountTooltip = true;
			}
			this.model.amount = otpModifier(roundToInterval(setMax(this.amountInput, this.maximumAmount)));
			this.amountInput = this.model.amount;
		},
		increaseAmount() {
			// eslint-disable-next-line operator-assignment
			this.model.amount =
				this.model.amount +
				(this.model.amount == OTP_FINAL_MAGIC_VALUE ? this.interval - (OTP_FINAL_MAGIC_VALUE - OTP_CONVERTABLE_MAGIC_VALUE) : this.interval);
		},
		decreaseAmount() {
			// eslint-disable-next-line operator-assignment
			this.model.amount = this.model.amount - this.interval;
		},
		increaseMonth() {
			this.monthSlider = Math.min(this.monthSlider + 1, this.durations.length - 1);
		},
		decreaseMonth() {
			this.monthSlider--;
		},
		closeTooltip() {
			this.amountTooltip = false;
		}
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		}
	},
	created() {
		this.model.amount = this.defaultAmount;
		this.model.duration = this.durations[0];
	}
};
